/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Minimum_Feature_3Inputs */

const et_plan_minimum_feature_3 = /** @type {(inputs: Plan_Minimum_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peamise otsingu-termini optimeerimine`)
};

const en_plan_minimum_feature_3 = /** @type {(inputs: Plan_Minimum_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main search term optimization`)
};

/**
* | output |
* | --- |
* | "Main search term optimization" |
*
* @param {Plan_Minimum_Feature_3Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_minimum_feature_3 = /** @type {((inputs?: Plan_Minimum_Feature_3Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Minimum_Feature_3Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_minimum_feature_3(inputs)
	return en_plan_minimum_feature_3(inputs)
});